import script from "./AdminUsersNew.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminUsersNew.vue?vue&type=script&setup=true&lang=js"

import "./AdminUsersNew.vue?vue&type=style&index=0&id=9334f808&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9334f808"]])

export default __exports__